import { useNavigate } from "react-router-dom";
import { setRole } from "@/lib/auth-mock";
import { Logo } from "@/components/ui/Logo";
import { useState } from "react";

export default function PortalLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  return (
    <div className="min-h-screen grid md:grid-cols-2">
      <div className="relative hidden md:flex items-center justify-center bg-ink-900 border-r border-ink-700/60 overflow-hidden">
        <div className="absolute inset-0 bg-grid-faint bg-[size:60px_60px] opacity-40" />
        <div className="relative text-center px-10">
          <Logo className="justify-center" />
          <h2 className="display-lg text-silver-50 mt-10">
            Your brand, <span className="text-brand-blue">measured.</span>
          </h2>
          <p className="text-silver-300 mt-4 max-w-sm mx-auto">
            Sign in to see your Spark progress, Brand Strength Score, and live ROI.
          </p>
        </div>
      </div>
      <div className="flex items-center justify-center p-10">
        <form
          onSubmit={(e) => { e.preventDefault(); setRole("client"); navigate("/portal"); }}
          className="panel p-8 w-full max-w-md"
        >
          <div className="eyebrow">// Client Portal</div>
          <h1 className="display-md text-silver-50 mt-2">Sign in</h1>
          <div className="mt-6 space-y-4">
            <div>
              <label className="eyebrow">// Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 w-full rounded-md border border-ink-700 bg-ink-900 px-4 py-3 text-silver-100 focus:border-brand-blue focus:outline-none"
                placeholder="you@company.com"
              />
            </div>
            <button className="btn-primary w-full justify-center">Continue</button>
          </div>
          <div className="hairline my-6" />
          <div className="text-xs text-silver-300 font-mono uppercase tracking-widest">
            // preview build · mock auth
          </div>
          <button
            type="button"
            onClick={() => { setRole("admin"); navigate("/admin"); }}
            className="mt-4 text-xs text-brand-red font-mono uppercase tracking-widest hover:underline"
          >
            → sign in as admin (internal)
          </button>
        </form>
      </div>
    </div>
  );
}
